import Styles from './index.module.scss';

interface Props {
	children: React.ReactNode;
	isBold?: boolean;
	accentColor?: string;
}

export const TextCell = ({ children, isBold, accentColor }: Props) => {
	return (
		<div className={`${Styles.textCell} ${isBold ? Styles.bolded : ''}`}>
			{accentColor && <div className={Styles.accent} style={{ background: accentColor }} />}
			<span>{children}</span>
		</div>
	);
};
